import * as React from 'react'

import { directorDashboardWebsitePath } from 'main/routes'
import { Hidden, Visible } from 'main/ui'

import DesktopView from './DesktopView'
import MobileView from './MobileView'

interface IProps {
  schoolId: number
}

export default function DirectorEditBar(props: IProps) {
  return (
    <>
      <Visible lg xl>
        <DesktopView onRequestEdit={handleClick} />
      </Visible>
      <Hidden lg xl>
        <MobileView onRequestEdit={handleClick} />
      </Hidden>
    </>
  )

  function handleClick() {
    const { schoolId } = props
    window.location.assign(directorDashboardWebsitePath(schoolId))
  }
}
